module.exports = __webpack_public_path__ + "img/cpu.80e86d32.png";